import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import classes from "../../style/Style.module.css";
import "../../style/Infoscreens.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  ROUTE_CUSTOMER_SUPPORT_SCREEN,
  ROUTE_MOBILE_VERIFICATION,
} from "../../Routes";
import { useLocation, useNavigate } from "react-router-dom";
import LogoutModal from "../../Components/LogoutModal";

const FatcaFailed = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  const { reason } = location.state || {};
  console.log(reason);
  const [showModal, setShowModal] = useState(false);

  const HandleBack = () => {
    setShowModal(true);
  };

  const handleLogoutConfirm = () => {
    Navigate(ROUTE_MOBILE_VERIFICATION);
  };
  const HandleSubmit = () => {
    Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN);
  };
  return (
    <div className="FatcaFailed_Main_Container">
      <div className="Header">
        <ArrowBackIosIcon className="Back_btn" onClick={HandleBack} />
      </div>
      <div className="BlankText_Screen_Container">
        <p className="Input_Heading_text">{reason}</p>
        <p className="Input_Heading_text_SubHeading">
          We couldn't proceed due to <br />
          errors in your submission.{" "}
        </p>
        <button className={classes.Submit_button} onClick={HandleSubmit}>
          Contact Dexterr Support{" "}
        </button>
      </div>
      <ToastContainer />
      <LogoutModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleLogoutConfirm}
      />
      ;
    </div>
  );
};

export default FatcaFailed;
